import React from 'react'
import { Alert, Box, Center, Modal } from '@mantine/core'
import { IconInfoCircle } from '@tabler/icons-react'

type FilterModalProps = {
    opened: boolean
    onClose: () => void
}

export const FiltersModal = ({ opened, onClose }: FilterModalProps) => {
    return (
        <Modal size='auto' opened={opened} onClose={onClose}>
            <Box w='80vw' maw='1800px' h='80vh'>
                <Center>
                    <Alert w={600} icon={<IconInfoCircle />} variant='light' color='blue' title="Coming Soon!">
                        This feature is still in development.
                    </Alert>
                </Center>
            </Box>
        </Modal>
    )
}
